import React, { useState } from "react";
import { InputField, SelectInput } from "../../../blueplanitUtils/InputField";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { getOptionsByPath } from '../../../utilsdata.js';
import { ADD_CLIENT,ADD_CLIENT_DEPARTMENT,CLIENT_INFO,CLIENT_SERVICESASSIGNED } from "../../../Dropdownmanager.jsx";

import Swal from "sweetalert2";
const Slots = ({ agencyData, setAgencyData }) => {
  const AllEmployees = useSelector((state) => state.employee.AllEmployees);
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);

  const initialSlot = {
    AssignedEmail: '',
    Phonenumber: '',
    ReportingClientContact: '',
    ReportingClientEmail: '',
    ReportingClientPhone: '',
    ReportingBlueplanitAssociate: '',
    AssignedAssociate: '',
    BackUpAssociate: '',
    Department: '',
    ServicesAssigned: '',
  };
  const [errors, setErrors] = useState([{}]);
  const Employees = AllEmployees
    .filter((emp) =>
      emp.employeestatus === "Active" &&
      (emp.department === "Operations" || emp.department === "Both")
    )
    .map((item, index) => ({
      key: index,
      label: `${item.firstname} ${item.lastname}`,
      value: `${item.firstname} ${item.lastname}`,
    }));
  const handleInputChange = (index, e) => {
    const { name, value } = e.target;

    const updated = agencyData.slots.map((slot, i) =>
      i === index ? { ...slot, [name]: value.trim() } : slot
    );
    setAgencyData(prev => ({ ...prev, slots: updated }));
    setErrors([]); // Or omit if errors are no longer used
  };



  const handleAddMore = () => {
    const currentContacts = Array.isArray(agencyData?.slots)
      ? agencyData.slots
      : [];
    setAgencyData({
      ...agencyData,
      slots: [...currentContacts, initialSlot]
    });
    setErrors(prev => [...prev, {}]);
  };

  const handleDelete = (index) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you really want to delete this item?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
    }).then((result) => {
      if (result.isConfirmed) {
        const updated = [...agencyData.slots];
        updated.splice(index, 1);
        setAgencyData(prev => ({ ...prev, slots: updated }));

        const updatedErrors = [...errors];
        updatedErrors.splice(index, 1);
        setErrors(updatedErrors);
      }
    })
  };


  return (
    <div className="card tab-box" style={{ marginTop: "6px" }}>
      <h3 className="mx-auto" style={{ fontSize: "20px",marginTop:"6px" }}>Slots</h3>
      <div className="form-scroll">
        {agencyData?.slots?.map((slot, index) => (
          <div className="card mb-0" key={index}>
            <div className="card-body">
              <h4 className="card-title">
                Slot {index + 1}
                <Link to="#" className="delete-icon float-end" onClick={() => handleDelete(index)}>
                  <i className="fa-regular fa-trash-can" />
                </Link>
              </h4>
              <div className="row">
                <div className="col-md-3 mb-2">
                  <InputField
                    label="Assigned Email"
                    name="AssignedEmail"
                    type="email"
                    value={slot.AssignedEmail}
                    onChange={(e) => handleInputChange(index, e)}
                    error={errors[index]?.AssignedEmail}
                  />
                </div>

                <div className="col-md-3 mb-2">
                  <InputField
                    label="Phone Number"
                    name="Phonenumber"
                    type="text"
                    value={slot.Phonenumber}
                    onChange={(e) => handleInputChange(index, e)}
                  />
                </div>

                <div className="col-md-3 mb-2">
                  <InputField
                    label="Reporting Client Contact"
                    name="ReportingClientContact"
                    type="text"
                    value={slot.ReportingClientContact}
                    onChange={(e) => handleInputChange(index, e)}
                  />
                </div>

                <div className="col-md-3 mb-2">
                  <InputField
                    label="Reporting Client Email"
                    name="ReportingClientEmail"
                    type="email"
                    value={slot.ReportingClientEmail}
                    onChange={(e) => handleInputChange(index, e)}
                    error={errors[index]?.ReportingClientEmail}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-3 mb-2">
                  <InputField
                    label="Reporting Client Phone"
                    name="ReportingClientPhone"
                    type="text"
                    value={slot.ReportingClientPhone}
                    onChange={(e) => handleInputChange(index, e)}
                  />
                </div>

                <div className="col-md-3 mb-2">
                  <SelectInput
                    label="Reporting Blueplanit Associate"
                    name="ReportingBlueplanitAssociate"
                    value={slot?.ReportingBlueplanitAssociate}
                    onChange={(e) =>
                      handleInputChange(index, {
                        target: {
                          name: "ReportingBlueplanitAssociate",
                          value: e,
                        },
                      })
                    }
                    options={Employees}
                    formControl
                  />
                </div>

                <div className="col-md-3 mb-2">
                  <SelectInput
                    label="Assigned Associate"
                    name="AssignedAssociate"
                    value={slot?.AssignedAssociate}
                    onChange={(e) =>
                      handleInputChange(index, {
                        target: {
                          name: "AssignedAssociate",
                          value: e,
                        },
                      })
                    }
                    options={Employees}
                    formControl
                  />
                </div>

                <div className="col-md-3 mb-2">
                  <SelectInput
                    label="Back-up Associate"
                    name="BackUpAssociate"
                    value={slot.BackUpAssociate}
                    onChange={(e) =>
                      handleInputChange(index, {
                        target: {
                          name: "BackUpAssociate",
                          value: e,
                        },
                      })
                    }
                    options={Employees}
                    formControl
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-3 mb-2">
                  <SelectInput
                    label="Department"
                    name="Department"
                    value={slot.Department}
                    onChange={(e) =>
                      handleInputChange(index, {
                        target: {
                          name: "Department",
                          value: e,
                        },
                      })
                    }
                    options={getOptionsByPath(NestedDatabucket, [ADD_CLIENT, ADD_CLIENT_DEPARTMENT])}
                    formControl
                  />
                </div>

                <div className="col-md-3 mb-2">
                  <SelectInput
                    label="Services Assigned"
                    name="ServicesAssigned"
                    value={slot.ServicesAssigned}
                    onChange={(e) =>
                      handleInputChange(index, {
                        target: {
                          name: "ServicesAssigned",
                          value: e,
                        },
                      })
                    }
                    options={getOptionsByPath(NestedDatabucket, [CLIENT_INFO, CLIENT_SERVICESASSIGNED])}
                    formControl
                  />
                </div>
              </div>
            </div>
          </div>
        ))}

        <div className="text-end mb-3">
          <button className="btn btn-sm btn-primary me-3" onClick={handleAddMore}>
            <i className="fa fa-plus pe-2" />
            Add Slot
          </button>
        </div>
      </div>
    </div>


  );
};

export default Slots;
